import React from 'react';
import './styles.scss';



const CircularProgress = ({ percentage }) => {
  // Ensure percentage is between 0 and 100
  const validPercentage = Math.min(100, Math.max(0, percentage));
  
  // Calculate the stroke-dasharray and stroke-dashoffset for the progress circle
  const radius = 120;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference - (validPercentage / 100) * circumference;
  
  return (
    <div className="circular-progress-container">
      <div className="circular-progress">
        <svg
          className="circular-progress-svg"
          viewBox="0 0 256 256"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background circle */}
          <circle
            className="progress-background"
            cx="128"
            cy="128"
            r={radius}
            strokeWidth="20"
            fill="none"
          />
          
          {/* Progress arc */}
          <circle
            className="progress-indicator"
            cx="128"
            cy="128"
            r={radius}
            strokeWidth="20"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            transform="rotate(-90, 128, 128)"
          />
        </svg>
        
        <div className="progress-text">
          <div className="percentage-value">{percentage}%</div>
          <div className="progress-label">Complete</div>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;